import moment from "moment";
import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../components/button";
import Sorting from "../../../components/sorting";
// import UserStatus from "../../../components/userstatus";
import { fireFilter } from './functions';
import Pagination from "../../../components/tablePagination";
import CopyComponent from "../../../components/copyComponent";
import InfoPopupclient from "./subcomponent";
import ClientInfoPanel from "./ClientInfoPanel";
import ToggleTestUser from "../Subcomponents/toogletestuser";
import FraudSignalBadge from "./FraudSignalBadge";

import { toast } from "react-toastify";
import "./client.css";
import { setAllStarterClientsPage, setAllStarterClientsrowsPerPage, setPathArray } from "../../../reducer/adminSlice";

var clientAvatarPalettes = [
  { background: '#ddeeff', color: '#2255aa' },
  { background: '#ffeedd', color: '#b86010' },
  { background: '#ddf5e8', color: '#1a7a45' },
  { background: '#f5ddff', color: '#7722aa' },
  { background: '#ffd6d6', color: '#cc2222' },
];
function getClientInitials(name) {
  if (!name) return '?';
  var parts = name.trim().split(' ').filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return name.substring(0, 2).toUpperCase();
}
function getClientAvatarStyle(name) {
  var idx = name ? name.charCodeAt(0) % clientAvatarPalettes.length : 0;
  return clientAvatarPalettes[idx];
}


const headers = [
  { label: "Screen Name", key: "screen_name" },
  { label: "Client Name", key: "client_name" },
  { label: "Email", key: "email" },
  { label: "Created", key: "created_at" },

];

export default function ClientTable(props) {
  const navigate = useNavigate();
  const {
    clients,
    onClickHandler,
    updateUser,
    issueResolved,
    resendEmail,
    filterListClients,
    getPaginationData,
    filterReset,
    setFilterValues,
    setSearchValues,
    searchValue,
    filterValues,
    showOprater,
    setShowOprater,
    operatorList,
    setOperatorList,
    optionsList,
    setOptionsList,
    filterValueOptions,
    setFilterValueOptions,
    setSortingNameOrderBy,
    setSortingTabType,
    allStarterClientsPage,
    setFilterOprater,
    filterOprater,
    zoomFilter,
    setZoomFilter,
    filterName,
    allStarterClientsrowsPerPage,
    setFilterName,
    isSearching,
  } = props;

  const dispatch = useDispatch()
  const [searchParams] = useSearchParams();
  const page = searchParams.get('page');
  const rowperpage = searchParams.get('rowperpage');
  const [active, setActive] = useState([]);
  const [panelClient, setPanelClient] = useState(null);
  const [panelDetails, setPanelDetails] = useState(null);
  const [panelLoading, setPanelLoading] = useState(false);

  useEffect(() => {
    if (page !== null) {

      dispatch(setAllStarterClientsPage(page));
    }
    if (rowperpage !== null) {
      dispatch(setAllStarterClientsrowsPerPage(rowperpage));
    }
  }, [])

  let info = localStorage.getItem('pagination') !== null ? JSON.parse(localStorage.getItem('pagination')) : { page: 1, rowsPerPage: 25 }
  const {
    allStarterClientsCount,
    allStarterClientsCountPage
  } = useSelector((state) => state.users);


  const navigateUser = (id) => {
    window.renderFirst = false
    dispatch(setPathArray(id.id));
    navigate(`/view/${id.id}?view=1&search=${filterValues}&searchName=${Object.values(searchValue)}&page=${info.page}&rowperpage=${info.rowsPerPage}&searchOprator=${showOprater}&searchFilterOprater=${filterOprater}`);
  };
  const navigateEdit = (e, id) => {
    window.renderFirst = false
    if (e.target.className == "referralode") {
      if (id.is_medium_refer_code == 1) {
        navigate(`/profile-edit/${id.medium_id}?view=1&search=${filterValues}&searchName=${Object.values(searchValue)}&page=${info.page}&rowperpage=${info.rowsPerPage}&searchOprator=${showOprater}&searchFilterOprater=${filterOprater}`);
      }
    } else if (e.target.className == "capitalize") {
      navigate(`/edit/${id.id}?view=1&search=${filterValues}&searchName=${Object.values(searchValue)}&page=${info.page}&rowperpage=${info.rowsPerPage}&searchOprator=${showOprater}&searchFilterOprater=${filterOprater}`);
    } else {

    }
  };

  const handleEditClick = (e, id) => {
    e.stopPropagation();
    window.renderFirst = false;
    navigate(`/edit/${id.id}?view=1&search=${filterValues}&searchName=${Object.values(searchValue)}&page=${info.page}&rowperpage=${info.rowsPerPage}&searchOprator=${showOprater}&searchFilterOprater=${filterOprater}`);
  };
  const openMoreInfo = (e, info) => {
    e.stopPropagation();
    // console.log(info,"info")
    let length = Object.keys(info.appointment_counts).length;
    console.log("admin info", info.appointment_counts, length);
    if (length !== 0) {

      // let array = [];
      // Object.values(info.appointment_counts).map((item) => {
      //     // array.push({heading: info:item});
      //   });
      console.log("", info.appointment_counts)

      setActive(info.appointment_counts);
      // console.log(array,"ayfdsg")
      window.loadModal2("#InfoPopupclient", "show");
    }
    else {
      toast.error("Nothing to display", { position: "top-center" })
    }
    return;
  };
    const handleCall = (params) => {
    console.log("params", params);
    filterListClients(params);
  };
  const handleScreenNameClick = function(e, item) {
    e.stopPropagation();
    setPanelClient(item);
    setPanelDetails({ general: { phone: item.phone || '', country: item.country || '', timezone: item.timezone || '', timezone_label: item.timezone_label || '' } });
    setPanelLoading(false);
  };
  var panelActions = panelClient ? [
    { label: 'View Profile', variant: 'primary', onClick: function(e) { e.stopPropagation(); window.renderFirst = false; dispatch(setPathArray(panelClient.id)); navigate('/view/' + panelClient.id + '?view=1&search=' + filterValues + '&searchName=' + Object.values(searchValue) + '&page=' + info.page + '&rowperpage=' + info.rowsPerPage + '&searchOprator=' + showOprater + '&searchFilterOprater=' + filterOprater); setPanelClient(null); } },
    { label: 'Edit Profile', variant: 'primary', onClick: function(e) { e.stopPropagation(); window.renderFirst = false; navigate('/edit/' + panelClient.id + '?view=1&search=' + filterValues + '&searchName=' + Object.values(searchValue) + '&page=' + info.page + '&rowperpage=' + info.rowsPerPage + '&searchOprator=' + showOprater + '&searchFilterOprater=' + filterOprater); setPanelClient(null); } },
    { label: parseInt(panelClient.status) === 4 ? 'UnRestrict' : 'Restrict', variant: 'warning', onClick: function(e) { e.stopPropagation(); updateUser(panelClient, parseInt(panelClient.status) === 4 ? 1 : 4, 'freeclient', ''); setPanelClient(null); } },
  ].concat(parseInt(panelClient.free_zoom_session) === 1 ? [{ label: 'Zoom Issue Resolved', variant: 'default', onClick: function(e) { e.stopPropagation(); issueResolved(panelClient); setPanelClient(null); } }] : []).concat([
    { label: 'Convert to Medium', variant: 'default', onClick: function(e) { e.stopPropagation(); updateUser(panelClient, 3, 'convertToMedium', ''); setPanelClient(null); } },
    { label: 'Info', variant: 'default', onClick: function(e) { openMoreInfo(e, panelClient); setPanelClient(null); } },
    { label: 'Send Activation Email', variant: 'default', onClick: function(e) { e.stopPropagation(); resendEmail(e, panelClient.id, "starter"); } },
    { label: 'Delete', variant: 'danger', onClick: function(e) { e.stopPropagation(); updateUser(panelClient, 3, 'delete', ''); setPanelClient(null); } },
  ]) : [];
  return (
    <>
      <div className="table-box-medium table-box-client overflow-scroll">
        <table className="caseTable">
          <tbody>
            <tr className="dark">
              <th>&nbsp;</th>
              <th>Screen Name & Email</th>
              <th > <div className="d-flex align-items-center"> <span>Client Name </span> <Sorting filterName={filterName} callApi={filterListClients} shortedName={"client_name"} tableName={"client"}
                setSortingNameOrderBy={setSortingNameOrderBy}
                setSortingTabType={setSortingTabType}
                tab={2}
              /></div></th>
              <th>Fraud Risk</th>
              <th>Test User</th>
              <th>Referral Code</th>
              <th>Tags</th>
              <th > <div className="d-flex align-items-center"> <span>Created </span> <Sorting filterName={filterName} callApi={filterListClients} shortedName={"created_at_order_by"} tableName={"client"}
                setSortingNameOrderBy={setSortingNameOrderBy}
                setSortingTabType={setSortingTabType}
                tab={2}
              /></div></th>
               <th > <div className="d-flex align-items-center"> <span>Volunteer Date </span> <Sorting filterName={filterName} callApi={handleCall} shortedName={"volunteer_date_order_by"} tableName={"client"}
                             setSortingNameOrderBy={setSortingNameOrderBy}
                             setSortingTabType={setSortingTabType}
                             tab={2}
                            /></div></th>
              {/* <th>Activation email</th> */}
              {/* <th>Online Status</th> */}
              <th>Action</th>
              {/* <th>Action</th> */}
            </tr>
            {isSearching ? (
            <tr>
	              <td colSpan="13" className="text-center py-4">
                <div className="custom-loader">
                  <div className="loader-dot"></div>
                  <div className="loader-dot"></div>
                  <div className="loader-dot"></div>
                </div>
                <div className="loader-text mt-2">Loading clients...</div>
              </td>
            </tr>
              )
            :clients.length > 0 ? (
              clients.map((client) => (
                <tr
                  className="innr"
                >
                  <td>
                    {" "}
                    <div style={Object.assign({}, getClientAvatarStyle(client.screen_name || (client.first_name || '') + ' ' + (client.last_name || '')), { width: 36, height: 36, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '700', fontSize: '13px', flexShrink: 0 })}>{getClientInitials(client.screen_name || ((client.first_name || '') + ' ' + (client.last_name || '')).trim())}</div>
                  </td>
                  <td onClick={(e) => handleScreenNameClick(e, client)} className="pointer">
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                      <div className="capitalize">
                        <span className="screen-name-link" onClick={(e) => handleScreenNameClick(e, client)}>
                          {client.screen_name ? client.screen_name : "N/A"}
                        </span>
                        {client.comments && (<b style={{ fontSize: '22px' }}>*</b>)}
                      </div>
                      <div style={{ fontSize: '12px', color: '#888' }}>
                        {client.email} <CopyComponent value={client.email} />
                      </div>
                    </div>
                  </td>
                  <td>
                    <p className="capitalize">
                      {client.first_name}&nbsp;{client.last_name}
                    </p>
	                  </td>
	                  <td><FraudSignalBadge client={client} /></td>
	                  <td><ToggleTestUser
                    clientId={client.id}
                    initialStatus={client.test_user === 1} // Set initial toggle state
                    onStatusChange={(id, newStatus) => {
                      console.log(`Client ${id} status changed to ${newStatus ? 'on' : 'off'}`);
                      // Additional handling if necessary
                    }}
                  />
                  </td>
                  <td className={client.is_medium_refer_code == 1 ? 'referralode' : ''} >{client.referralCode}</td>
                  <td><div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>{client.extra_tags !== null ? client.extra_tags.split(',').map(function(tag, i) { return tag.trim() ? <span key={i} className="tag-badge">{tag.trim()}</span> : null; }) : "-"}</div></td>
                  <td>
                    {client.created_at ? (
                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <span style={{ margin: 0, float: 'none', width: 'auto' }}>{client.created_at.split(' ')[0]}</span>
                        <span style={{ margin: 0, float: 'none', width: 'auto' }}>{client.created_at.split(' ').slice(1).join(' ')}</span>
                      </div>
                    ) : ''}
                  </td>
                  <td>
                    {client.volunteer_date ? client.volunteer_date : "-"}
                  </td>
                  {/* <td>
                    <Button
                      status={client.resent_status}
                      onClick={(e) => resendEmail(e, client.id, "starter")}
                      type="button"
                      className="resend-btn"
                      title="Resend"
                    />
                  </td> */}
                  {/* <td>
                    <UserStatus status={client.is_available} />
                  </td> */}
                  <td>
                    <button
                      onClick={(e) => handleEditClick(e, client)}
                      style={{ padding: '5px 14px', fontSize: '12px', fontWeight: '600', background: '#d5a67b', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer', whiteSpace: 'nowrap' }}
                    >
                      Edit
                    </button>
                  </td>
                  {/* <td className="dott">
                    <img
                      onClick={(e) => onClickHandler(e, client.id, "starter")}
                      src="/images/Unionblck.png"
                      className="padding-10"
                      alt="unblock"
                    />

                    {client.client_status && (
                      <div className="approve-btn-1 approve-btn z-index-1">
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            navigateUser(client);
                          }}
                        >
                          View
                        </span>
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            updateUser(
                              client,
                              parseInt(client.status) === 4 ? 1 : 4,
                              "freeclient",
                              ""
                            );
                          }}
                        >
                          {parseInt(client.status) === 4
                            ? "UnRestrict"
                            : "Restrict"}
                        </span>
                        {parseInt(client.free_zoom_session) === 1 && (
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            issueResolved(client);
                          }}
                        >
                          Zoom Issue Resolved
                        </span>
                        )}
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            updateUser(client, 3, "delete", "");
                          }}
                        >
                          Delete
                        </span>
                          <span
                          onClick={(e) => {
                            e.stopPropagation();
                            updateUser(client, 3, "convertToMedium", "");
                          }}
                        >
                          Convert to Medium
                        </span>
                        <span
                          onClick={(e) => openMoreInfo(e, client)}
                        >
                          Info
                        </span>
                      </div>
                    )}
                  </td> */}
                  {/* <td>
                    <Link to={`/view/${client.id}`}>
                      <img src="../images/blue-e.png" alt="view profile" />
                      View Profile
                    </Link>
                  </td> */}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={13} style={{ padding: '48px 0', textAlign: 'center' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="8" r="4" stroke="#d5a67b" strokeWidth="1.5"/>
                      <path d="M4 20c0-4 3.582-7 8-7s8 3 8 7" stroke="#d5a67b" strokeWidth="1.5" strokeLinecap="round"/>
                    </svg>
                    <p style={{ margin: 0, fontSize: '15px', fontWeight: '600', color: '#485257' }}>No clients found</p>
                    <p style={{ margin: 0, fontSize: '13px', color: '#aaa' }}>Try adjusting your filters or load all records</p>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <Pagination rowsPerPageOptions={[25, 50, 100]} count={allStarterClientsCountPage} activeTab="starterclient" getPaginationData={getPaginationData}

          allStarterClientsPage={allStarterClientsPage}
          allStarterClientsrowsPerPage={allStarterClientsrowsPerPage} />
        <InfoPopupclient feedBackinfo={active} />
        <ClientInfoPanel
          client={panelClient}
          details={panelDetails}
          detailsLoading={panelLoading}
          onClose={() => setPanelClient(null)}
          actions={panelActions}
        />
      </div>
    </>
  );
}
